import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, computed, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable, catchError, map, of, tap, } from 'rxjs';
import { CentroOperacionByID, Co, ResponseCo } from '../interfaces/co.interface';
import { DataSolicitudesRespont, Documento, ParamsConsultarSolicitudes, ResponSolicitudClean, RespontSolicitudes, SolicitudClean } from '../interfaces/respontSolicitusde.iterface';
import { AuthService } from 'src/app/auth/services/auth.service';
import { DataSolicitudes, DatumDocumento, ResponseHistorial } from '../interfaces/historial-solicitudes.interfaces';
import { ResponseDocumento, ResponseSolicitud, SolicitudResp } from '../interfaces/solicitud.interface';
import { CoreService } from 'src/app/shared/services/core-service.service';


@Injectable({providedIn: 'root'})
export class ConsultaService {

  private baseUrl: string = environment.baseUrlAuth;
  private baseUrlJS: string = environment.baseUrl;

  private http          =inject(HttpClient);
  private coreService   = inject(CoreService)


  private getAuthHeaders(): { headers: HttpHeaders; params: HttpParams } {
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    });

    const params = new HttpParams().set('like', 'true').set('limitMax', '20');

    return { headers, params };
  }

  private getAuthHeadersFile(): { headers: HttpHeaders; params: HttpParams } {
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'apllication/form-data',
      'Authorization': `Bearer ${authToken}`,
    });

    const params = new HttpParams().set('like', 'true').set('limitMax', '20');

    return { headers, params };
  }

  getSolicitudesList(consulta: ParamsConsultarSolicitudes): Observable<RespontSolicitudes>{
      let params = new HttpParams();

      // Definir un objeto con las propiedades y valores de consulta
      const queryParams: any = {
        offset:           consulta.offset,
        limit:            consulta.limit,
        estadoSolic:      consulta.estadoSolic,
        terceroId:        consulta.terceroId,
        tipoDoc:          consulta.tipoDoc,
        centroOp:         consulta.centroOp,
        fechaInicial:     consulta.fechaInicial?.toUTCString(),
        fechaFinal:       consulta.fechaFinal?.toUTCString(),
        numeroDoc:        consulta.numeroDoc,
        asignadoA:        consulta.asignadoA,
        creadoPor:        consulta.creadoPor,
        consecutivo:      consulta.consecutivo?.toString(),
        nombreFolio:      consulta.nombreFolio,
        viweSubFolio:     consulta.viweSubFolio,
      };

      // Iterar sobre las propiedades y agregarlas a params si no son undefined o null
      for (const key of Object.keys(queryParams)) {
        const value = queryParams[key];
        if (value !== undefined && value !== null) {
          params =  params.set(key, value);
        }
      }

      return this.http.get<RespontSolicitudes>(`${this.baseUrl}/api/documentos/solicitudes`,{ params, headers: this.getAuthHeaders().headers})
      .pipe(
        map((resp: RespontSolicitudes) => {
          resp.data.forEach((solicitud: DataSolicitudesRespont) => {
            // Separar los documentos en dos grupos
            const documentosNoEliminados = solicitud.documentos?.filter((doc: Documento) => doc.isDelete === false);
            const documentosEliminados = solicitud.documentos?.filter((doc: Documento) => doc.isDelete === true);

            // Ordenar los documentos por fecha de subida
            documentosNoEliminados.sort((a, b) => new Date(b.fechaSubida).getTime() - new Date(a.fechaSubida).getTime());
            documentosEliminados.sort((a, b) => new Date(b.fechaSubida).getTime() - new Date(a.fechaSubida).getTime());

            // Combinar los dos grupos, primero los no eliminados y luego los eliminados
            solicitud.documentos = [...documentosNoEliminados, ...documentosEliminados];

            // Organizar las asignaciones por fecha de creación
            solicitud.asignaciones.sort((a, b) => new Date(b.fechaCreacion).getTime() - new Date(a.fechaCreacion).getTime());
          });
          return resp;
        })
      );
  }

  getSolicitudesCleanList(consulta: ParamsConsultarSolicitudes): Observable<ResponSolicitudClean>{
    const url = `${this.baseUrl}/api/documentos/solicitudes/clean`;
    const { headers } = this.getAuthHeaders();
    let params = new HttpParams();

    // Definir un objeto con las propiedades y valores de consulta
    const queryParams: any = {
      offset:           consulta.offset,
      limit:            consulta.limit,
      estadoSolic:      consulta.estadoSolic,
      terceroId:        consulta.terceroId,
      tipoDoc:          consulta.tipoDoc,
      centroOp:         consulta.centroOp,
      fechaInicial:     consulta.fechaInicial?.toUTCString(),
      fechaFinal:       consulta.fechaFinal?.toUTCString(),
      numeroDoc:        consulta.numeroDoc,
      asignadoA:        consulta.asignadoA,
      creadoPor:        consulta.creadoPor,
      consecutivo:      consulta.consecutivo?.toString(),
      nombreFolio:      consulta.nombreFolio,
      viweSubFolio:     consulta.viweSubFolio,
    };

    // Iterar sobre las propiedades y agregarlas a params si no son undefined o null
    for (const key of Object.keys(queryParams)) {
      const value = queryParams[key];
      if (value !== undefined && value !== null) {
        params = params.set(key, value);
      }
    }

    return this.http.get<ResponSolicitudClean>(url,{ params, headers}).pipe(
      map((resp: ResponSolicitudClean) => {
        return resp;
      }),
      catchError((error) => {
        console.error('Error en la petición', error);
        this.coreService.openErrorSnackbar('Error en la petición', 'error');
        return of({ lengthData: 0, data: [] });
      }),
    )
  }
  //solicitudes/get-multiples?offset=0&limit=10&viweSubFolio=false&consecutivo=86

  getSolicitudsCleanGet(consulta: ParamsConsultarSolicitudes): Observable<ResponSolicitudClean> {
    const url = `${this.baseUrl}/api/documentos/solicitudes/get-multiples`;
    const { headers } = this.getAuthHeaders();
    let params = new HttpParams();

    // Definir un objeto con las propiedades y valores de consulta
    const queryParams: any = {
      offset:           consulta.offset,
      limit:            consulta.limit,
      estadoSolic:      consulta.estadoSolic,
      terceroId:        consulta.terceroId,
      tipoDoc:          consulta.tipoDoc,
      centroOp:         consulta.centroOp,
      fechaInicial:     consulta.fechaInicial?.toUTCString(),
      fechaFinal:       consulta.fechaFinal?.toUTCString(),
      numeroDoc:        consulta.numeroDoc,
      asignadoA:        consulta.asignadoA,
      creadoPor:        consulta.creadoPor,
      consecutivo:      consulta.consecutivo?.toString(),
      nombreFolio:      consulta.nombreFolio,
      viweSubFolio:     consulta.viweSubFolio,
    };

    // Iterar sobre las propiedades y agregarlas a params si no son undefined o null
    for (const key of Object.keys(queryParams)) {
      const value = queryParams[key];
      if (value !== undefined && value !== null) {
        params = params.set(key, value);
      }
    }

    return this.http.get<ResponSolicitudClean>(url,{ params, headers}).pipe(
      map((resp: ResponSolicitudClean) => {
        resp.data.forEach((solicitud: SolicitudClean) => {
          // Ordenar los documentos por fecha de subida
          solicitud.documentos?.sort((a, b) => new Date(b.fechaSubida).getTime() - new Date(a.fechaSubida).getTime());

          // Organizar las asignaciones por fecha de creación
          solicitud.asignaciones.sort((a, b) => new Date(b.fechaCreacion).getTime() - new Date(a.fechaCreacion).getTime());
        });
        return resp;
      }),
      catchError((error) => {
        console.error('Error en la petición', error);
        this.coreService.openErrorSnackbar('Error en la petición', 'error');
        return of({ lengthData: 0, data: [] });
      }),
    )

  }


  getFileBlob(report: ParamsConsultarSolicitudes) {
    let params = new HttpParams();

    const queryParams: any = {
      offset:           report.offset,
      limit:            report.limit,
      estadoSolic:      report.estadoSolic,
      terceroId:        report.terceroId,
      tipoDoc:          report.tipoDoc,
      centroOp:         report.centroOp,
      fechaInicial:     report.fechaInicial?.toUTCString(),
      fechaFinal:       report.fechaFinal?.toUTCString(),
      numeroDoc:        report.numeroDoc,
      asignadoA:        report.asignadoA,
      creadoPor:        report.creadoPor,
      consecutivo:      report.consecutivo?.toString(),
    };

    for (const key of Object.keys(queryParams)) {
      const value = queryParams[key];
      if (value !== undefined && value !== null) {
        params =  params.set(key, value);
      }
    }

    return this.http.get<ArrayBuffer>(`${this.baseUrl}/api/generate-report-file/excel/consult`,{ params, headers: this.getAuthHeadersFile().headers, responseType: 'arraybuffer' as 'json' });

  }


  getSolicitudesListHistory(consulta: ParamsConsultarSolicitudes): Observable<ResponseHistorial> {
    let params = new HttpParams();

    // Definir un objeto con las propiedades y valores de consulta
    const queryParams: any = {
      offset: consulta.offset,
      limit: consulta.limit,
    };

    // Iterar sobre las propiedades y agregarlas a params si no son undefined o null
    for (const key of Object.keys(queryParams)) {
      const value = queryParams[key];
      if (value !== undefined && value !== null) {
        params =  params.set(key, value);
      }
    }

    return this.http.get<ResponseHistorial>(`${this.baseUrl}/api/documentos/historial-solicitudes`,
  {
    params,
    headers: this.getAuthHeaders().headers
  })
  .pipe(
    map((resp: ResponseHistorial) => {
      resp.data.forEach((solicitud: DataSolicitudes) => {
        // Separar los documentos en dos grupos
        const documentosNoEliminados = solicitud.documentos.filter((doc: DatumDocumento) => doc.isDelete === false);
        const documentosEliminados = solicitud.documentos.filter((doc: DatumDocumento) => doc.isDelete === true);

        // Ordenar los documentos por fecha de creación
        documentosNoEliminados.sort((a, b) => new Date(b.fechaSubida).getTime() - new Date(a.fechaSubida).getTime());
        documentosEliminados.sort((a, b) => new Date(b.fechaSubida).getTime() - new Date(a.fechaSubida).getTime());

        // Combinar los dos grupos, primero los no eliminados y luego los eliminados
        solicitud.documentos = [...documentosNoEliminados, ...documentosEliminados];

        // Organizar las asignaciones por fecha de creación
        solicitud.asignaciones.sort((a, b) => new Date(b.fechaCreacion).getTime() - new Date(a.fechaCreacion).getTime());
      });
      return resp;
    }));
  }

  getFileBlobHistory(report: ParamsConsultarSolicitudes) {
    let params = new HttpParams();

    const queryParams: any = {
      offset:           report.offset,
      limit:            report.limit,
    };

    for (const key of Object.keys(queryParams)) {
      const value = queryParams[key];
      if (value !== undefined && value !== null) {
        params =  params.set(key, value);
      }
    }

    return this.http.get<ArrayBuffer>(`${this.baseUrl}/api/generate-report-file/excel/tracing`,{ params, headers: this.getAuthHeadersFile().headers, responseType: 'arraybuffer' as 'json' });

  }


  getConsultFolioClean (id: string): Observable<ResponseSolicitud> {
    const url = `${this.baseUrl}/api/documentos/solicitudes/detalleSolicitud/${id}`;
    const { headers } = this.getAuthHeaders();

    return this.http.get<ResponseSolicitud>(url,{ headers })
    .pipe(
      map((resp: ResponseSolicitud) => {
        resp.data.forEach((solicitud: SolicitudResp) => {
          // Separar los documentos en dos grupos
          const documentosNoEliminados = solicitud.documentos.filter((doc: ResponseDocumento) => doc.isDelete === false);
          const documentosEliminados = solicitud.documentos.filter((doc: ResponseDocumento) => doc.isDelete === true);

          // Ordenar los documentos por fecha de subida
          documentosNoEliminados.sort((a, b) => new Date(b.fechaSubida).getTime() - new Date(a.fechaSubida).getTime());
          documentosEliminados.sort((a, b) => new Date(b.fechaSubida).getTime() - new Date(a.fechaSubida).getTime());

          // Combinar los dos grupos, primero los no eliminados y luego los eliminados
          solicitud.documentos = [...documentosNoEliminados, ...documentosEliminados];

          // Organizar las asignaciones por fecha de creación
          solicitud.asignaciones.sort((a, b) => new Date(b.fechaCreacion).getTime() - new Date(a.fechaCreacion).getTime());

          solicitud.children = solicitud.children.map((child: any) => {
            const documentChilNoEliminados = child.documentos.filter((doc: any) => doc.isDelete === false);
            const documentChilEliminados = child.documentos.filter((doc: any) => doc.isDelete === true);

            documentChilNoEliminados.sort((a: any, b:any) => new Date(b.fechaSubida).getTime() - new Date(a.fechaSubida).getTime());
            documentChilEliminados.sort((a:any, b:any) => new Date(b.fechaSubida).getTime() - new Date(a.fechaSubida).getTime());

            child.documentos = [...documentChilNoEliminados, ...documentChilEliminados];

            child.asignaciones.sort((a: any, b:any) => new Date(b.fechaCreacion).getTime() - new Date(a.fechaCreacion).getTime());
           return child;
          });
        });
        return resp;
      })
    );;
  }

  getConsultFolio(folio: string, idYourself:string| null = null, viweSubFolio: boolean | null = null): Observable<ResponseSolicitud> {
    //http://localhost:3000/api/documentos/solicitudes?offset=0&limit=10&consecutivo=25
    let params = new HttpParams();

    const queryParams: any = {
      offset: 0,
      limit: 10,
      viweSubFolio: viweSubFolio,
      consecutivo: folio.toString(),
      asignadoA: idYourself
    };

    for (const key of Object.keys(queryParams)) {
      const value = queryParams[key];
      if (value !== undefined && value !== null) {
        params =  params.set(key, value);
      }
    }


    return this.http.get<ResponseSolicitud>(`${this.baseUrl}/api/documentos/solicitudes`,{ params ,headers: this.getAuthHeaders().headers })
    .pipe(
      map((resp: ResponseSolicitud) => {
        resp.data.forEach((solicitud: SolicitudResp) => {
          // Separar los documentos en dos grupos
          const documentosNoEliminados = solicitud.documentos.filter((doc: ResponseDocumento) => doc.isDelete === false);
          const documentosEliminados = solicitud.documentos.filter((doc: ResponseDocumento) => doc.isDelete === true);

          // Ordenar los documentos por fecha de subida
          documentosNoEliminados.sort((a, b) => new Date(b.fechaSubida).getTime() - new Date(a.fechaSubida).getTime());
          documentosEliminados.sort((a, b) => new Date(b.fechaSubida).getTime() - new Date(a.fechaSubida).getTime());

          // Combinar los dos grupos, primero los no eliminados y luego los eliminados
          solicitud.documentos = [...documentosNoEliminados, ...documentosEliminados];

          // Organizar las asignaciones por fecha de creación
          solicitud.asignaciones.sort((a, b) => new Date(b.fechaCreacion).getTime() - new Date(a.fechaCreacion).getTime());
        });
        return resp;
      })
    );
  }

  getFoliosQuerty(nameFolio: string, asignadoA?: string | null, viweSubFolio: boolean | null = null): Observable<RespontSolicitudes>{
    let params = new HttpParams();

    const queryParams: any = {
      offset:           0,
      limit:            10,
      viweSubFolio: viweSubFolio,
      nombreFolio:      nameFolio,
      asignadoA:        asignadoA,
    };

    // si no llega asignadoA, se elimina del objeto queryParams
    if (!asignadoA) {
      delete queryParams.asignadoA;
    }

    // Iterar sobre las propiedades y agregarlas a params si no son undefined o null
    for (const key of Object.keys(queryParams)) {
      const value = queryParams[key];
      if (value !== undefined && value !== null) {
        params =  params.set(key, value);
      }
    }

    return this.http.get<RespontSolicitudes>(`${this.baseUrl}/api/documentos/solicitudes`,{ params, headers: this.getAuthHeaders().headers})
    .pipe(
      map((resp: RespontSolicitudes | any) => {
          resp.data.forEach((solicitud: DataSolicitudesRespont) => {
            // Separar los documentos en dos grupos
            const documentosNoEliminados = solicitud.documentos.filter((doc: Documento) => doc.isDelete === false);
            const documentosEliminados = solicitud.documentos.filter((doc: Documento) => doc.isDelete === true);

            // Ordenar los documentos por fecha de subida
            documentosNoEliminados.sort((a, b) => new Date(b.fechaSubida).getTime() - new Date(a.fechaSubida).getTime());
            documentosEliminados.sort((a, b) => new Date(b.fechaSubida).getTime() - new Date(a.fechaSubida).getTime());

            // Combinar los dos grupos, primero los no eliminados y luego los eliminados
            solicitud.documentos = [...documentosNoEliminados, ...documentosEliminados];

            // Organizar las asignaciones por fecha de creación
            solicitud.asignaciones.sort((a, b) => new Date(b.fechaCreacion).getTime() - new Date(a.fechaCreacion).getTime());
          });
          return resp;
      })
    );
  }


  getFolioByConsecutivo(consecutivo: string): Observable<RespontSolicitudes> {
    let params = new HttpParams();

    const queryParams: any = {
      offset: 0,
      limit: 10,
      consecutivo: consecutivo.toString(),
    };

    for (const key of Object.keys(queryParams)) {
      const value = queryParams[key];
      if (value !== undefined && value !== null) {
        params =  params.set(key, value);
      }
    }

    return this.http.get<RespontSolicitudes>(`${this.baseUrl}/api/documentos/solicitudes`,{ params, headers: this.getAuthHeaders().headers })
    .pipe(
      map((resp: RespontSolicitudes) => {
        resp.data.forEach((solicitud: DataSolicitudesRespont) => {
          // Separar los documentos en dos grupos
          const documentosNoEliminados = solicitud.documentos.filter((doc: Documento) => doc.isDelete === false);
          const documentosEliminados = solicitud.documentos.filter((doc: Documento) => doc.isDelete === true);

          // Ordenar los documentos por fecha de subida
          documentosNoEliminados.sort((a, b) => new Date(b.fechaSubida).getTime() - new Date(a.fechaSubida).getTime());
          documentosEliminados.sort((a, b) => new Date(b.fechaSubida).getTime() - new Date(a.fechaSubida).getTime());

          // Combinar los dos grupos, primero los no eliminados y luego los eliminados
          solicitud.documentos = [...documentosNoEliminados, ...documentosEliminados];

          // Organizar las asignaciones por fecha de creación
          solicitud.asignaciones.sort((a, b) => new Date(b.fechaCreacion).getTime() - new Date(a.fechaCreacion).getTime());
        });
        return resp;
      })
    );
  }

  getChildrensFolioById(id: string): Observable<ResponseSolicitud> {
    return this.http.get<ResponseSolicitud>(`${this.baseUrl}/api/documentos/solicitudes/children/${id}`,{ headers: this.getAuthHeaders().headers })
    .pipe(
      map((resp: ResponseSolicitud) => {
        // console.log(resp);
        resp.data.forEach((solicitud: SolicitudResp) => {
          // Separar los documentos en dos grupos
          const documentosNoEliminados = solicitud.documentos.filter((doc: ResponseDocumento) => doc.isDelete === false);
          const documentosEliminados = solicitud.documentos.filter((doc: ResponseDocumento) => doc.isDelete === true);

          // Ordenar los documentos por fecha de subida
          documentosNoEliminados.sort((a, b) => new Date(b.fechaSubida).getTime() - new Date(a.fechaSubida).getTime());
          documentosEliminados.sort((a, b) => new Date(b.fechaSubida).getTime() - new Date(a.fechaSubida).getTime());

          // Combinar los dos grupos, primero los no eliminados y luego los eliminados
          solicitud.documentos = [...documentosNoEliminados, ...documentosEliminados];

          // Organizar las asignaciones por fecha de creación
          solicitud.asignaciones.sort((a, b) => new Date(b.fechaCreacion).getTime() - new Date(a.fechaCreacion).getTime());
        });
        return resp;
      })
    );
  }




}
